import AdvancedFilterProvider from "../../providers/advancedFilterProvider";
import {TAdvancedFilter} from "../../models/advancedFilter";
import storeFactoryTrackedMixin from "~/mixins/storeFactoryMixins/storeFactoryTrackedMixin";
import AdvancedFilterEventBus from "../../../modelViews/buses/advancedFilterEventBus";

export default function (initialAdvancedFilter: TAdvancedFilter) {
  const baseStore = {
    namespaced: true,
    state: {
      advancedFilter: initialAdvancedFilter,
      advancedFilterProvider: new AdvancedFilterProvider(),
    },
    actions: {
      saveToServer({commit, state, getters}): Promise<any> {
        return new Promise((resolve, reject) => {
          const unpersistedChangeSets = getters.unpersistedChangeSets;
          if (unpersistedChangeSets.length === 0) {
            resolve({});
            return;
          }

          state.advancedFilterProvider.save(state.advancedFilter, getters.getJsonChanges).then(([data]) => {
            commit('persistChanges', {changes: unpersistedChangeSets});
            if (state.advancedFilter.id) AdvancedFilterEventBus.emitEdited();
            commit(MUTATIONS.updateAdvancedFilter, {advancedFilterJson: data.advanced_filter});
            resolve(data);
          }).catch(() => reject());
        });
      },
      find({commit, state, getters}, {id}: { id: string }): Promise<any> {
        return new Promise((resolve, reject) => {
          state.advancedFilterProvider.fetchOne(id).then(([data]) => {
            commit(MUTATIONS.updateAdvancedFilter, {advancedFilterJson: data.advanced_filter});
            resolve(data);
          }).catch(() => reject());
        });
      },
      destroy({commit, state, getters}): Promise<any> {
        return new Promise((resolve, reject) => {
          state.advancedFilterProvider.destroy(state.advancedFilter).then(([data]) => {
            commit('clearUndoRedo');
            resolve(data);
          }).catch(() => reject());
        });
      },
    },
    mutations: {
      [MUTATIONS.updateAdvancedFilter](state, {advancedFilterJson}): void {
        state.advancedFilter.loadFromJson(advancedFilterJson);
      },
      [MUTATIONS.setAdvancedFilter](state, {advancedFilter}: { advancedFilter: TAdvancedFilter }): void {
        state.advancedFilter = advancedFilter;
      },
    },
  };

  const trackedMixinOverwrites = {
    getters: {
      getJsonChanges: (state, getters) => {
        return state.helper.getChangesJsonFromChangeSets(state.advancedFilter, getters.unpersistedDoneChangeSets, true);
      },
    },
  };

  return window.AppConfig.mergeJson(
    baseStore,
    storeFactoryTrackedMixin(initialAdvancedFilter),
    trackedMixinOverwrites,
  );
}

export const MUTATIONS = {
  updateAdvancedFilter: 'updateAdvancedFilter',
  setAdvancedFilter: 'setAdvancedFilter',
};